import { Badge } from '@/components/ui/badge';
import { T } from 'gt-react';

export function getInvoiceStatusBadge(status: string) {
  switch (status) {
    case 'draft':
      return (
        <Badge variant="outline">
          <T context="AR invoice status badge">Draft</T>
        </Badge>
      );
    case 'open':
      return (
        <Badge variant="secondary">
          <T context="AR invoice status badge">Open</T>
        </Badge>
      );
    case 'closed':
      return (
        <Badge variant="default">
          <T context="AR invoice status badge">Closed</T>
        </Badge>
      );
    case 'voided':
      return (
        <Badge variant="outline" className="text-muted-foreground">
          <T context="AR invoice status badge">Voided</T>
        </Badge>
      );
    default:
      return <Badge variant="secondary">{status}</Badge>;
  }
}
